import { connect } from 'react-redux';
import ChangePlanConfirmation from './ChangePlanConfirmation';
import { changePlan, updateChangePlanDate } from '../../modules/Subscription';
import { formatDaysLeft, getRenewalDate } from '../../lib/date-utils';
import I18n from '../../lib/i18n';
import {
  currentSubscriptionDaysLeftSelector,
  currentSubscriptionNextRenewalDateSelector,
} from '../../modules/Dashboard';
import { newOfferPeriodicitySelector, newOfferPriceSelector, newOfferSelector } from '../../modules/NewOffer/selectors';
import { changePlanDateSelector } from '../../modules/Plan/selectors';

export const formatConfirmationModalProps = (
  isChangePlanScene?: boolean,
  nextRenewalDate?: number,
  changePlanDate?: number,
  daysLeft?: number
) => {
  let confirmButtonText = I18n.t('selectThisPlan');
  let confirmModalContent = I18n.t('selectPlanConfirmContent');

  if (isChangePlanScene) {
    if (changePlanDate === nextRenewalDate) {
      const formatedDaysLeft = formatDaysLeft(daysLeft);
      confirmButtonText = I18n.t('changePlanAtNextBill', { days: formatedDaysLeft });
      confirmModalContent = I18n.t('delayedChangePlanConfirmContent', { date: getRenewalDate(nextRenewalDate) });
    } else {
      confirmButtonText = I18n.t('changePlanNow');
      confirmModalContent = I18n.t('changePlanNowConfirmContent');
    }
  }

  return { confirmButtonText, confirmModalContent };
};

const mapStateToProps = (state, ownProps) => {
  const nextRenewalDate = currentSubscriptionNextRenewalDateSelector(state);
  const changePlanDate = changePlanDateSelector(state);
  const daysLeft = currentSubscriptionDaysLeftSelector(state);
  const isChangePlanScene = ownProps.route.name.includes('changePlan');

  const confirmationModalProps = formatConfirmationModalProps(
    isChangePlanScene,
    nextRenewalDate,
    changePlanDate,
    daysLeft
  );

  return {
    ...confirmationModalProps,
    price: newOfferPriceSelector(state),
    periodicity: newOfferPeriodicitySelector(state),
    offer: newOfferSelector(state),
    changePlanNow: !changePlanDate,
    nextRenewalDate,
    daysLeft: currentSubscriptionDaysLeftSelector(state),
    allowChangePlanDate: isChangePlanScene,
  };
};

const mapDispatchToProps = {
  updateChangePlanDate,
  changePlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePlanConfirmation);
